module.exports = __webpack_public_path__ + "media/img/clients-modal/together-f1ae5d97fcc2c1b1aa856669ef555353.svg";